// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 320px) and (max-width: 480px) {
  .title {
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
  }
  /* This is the Parant Row for ALL Content (image and text) */
  .content-row {
    justify-content: center;
    height: 1000px;
  }
  /* Right hand side of content row */
  .text-column {
    display: flex;
    flex-direction: column;
    gap: 5px;
    height: 375px;
    width: 375px;
  }
  .text-row-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 5px;
    width: 375px;
    height: 16px;
    background-color: #212529;
  }
  .text-container {
    color: white;
    margin: 5px;
    flex: 1;
    text-align: justify;
    overflow-y: auto;
    justify-content: flex-start;
    height: 1000px;
  }
  .text-container::-webkit-scrollbar {
    width: 3px;
  }
  .text-container::-webkit-scrollbar-track {
    background: #212529;
  }
  .text-container::-webkit-scrollbar-thumb {
    background-color: black;
    border-radius: 3px;
    border: 0px solid #212529;
    opacity: 0.5;
  }
  /* .text-container {
    scrollbar-color: black #212529;
    scrollbar-width: none;
  } */
  .text {
    background-color: #212529;
  }
  /* Left hand side of content row */
  .image-container {
    justify-content: right;
    height: 375px;
    width: 375px;
  }
  .image-container img {
    height: 375px;
    width: 375px;
    /* position: absolute; */
  }
  .rounded-image {
    /* border-radius: 8px; */
    height: 375px;
    /* float: right !important; */
  }
  .dj-name-container {
    display: flex;
    max-width: fit-content;
    margin: 0 2px 0 0px;
    padding-right: 0px;
    align-items: top;
  }
  .dj-name {
    color: white;
    font-size: 20px;
    font-style: bold;
    min-width: fit-content;
    margin: 0 0 0 0px;
  }
  /* BUTTON */
  .buttons-container {
    display: flex;
    margin: 0 0 0 0;
    padding-left: 0px;
    align-items: center;
  }
  .select-button {
    background-color: transparent;
    border: 1px solid white;
    border-radius: 20px;
    color: white;
    font-size: 8px;
    padding: 1px 3px;
    cursor: pointer;
    align-items: center;
  }
  .select-button:hover {
    background-color: orange;
    color: white;
  }
  /* MICROOHONE */
  .microphone-icon {
    margin: 0 2px 0 0px;
    cursor: pointer;
    color: white;
    size: 18px;
    align-items: center;
  }
  .microphone-icon:hover {
    color: orange;
  }
  @keyframes blinking {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
  .microphone-icon.playing {
    color: orange;
    animation: blinking 1s infinite;
  }
  .microphone-icon.paused {
    color: orange;
    opacity: 0.5;
  }
}
@media (min-width: 481px) and (max-width: 1024px) {
  .title {
    color: white;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  /* This is the Parant Row for ALL Content (image and text) */
  .content-row {
    justify-content: center;
    height: 1000px;
  }
  /* Right hand side of content row */
  .text-column {
    display: flex;
    flex-direction: column;
    gap: 5px;
    height: 474px;
    width: 474px;
  }
  .text-row-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 5px;
    width: 474px;
    height: 20px;
    background-color: #212529;
  }
  .text-container {
    color: white;
    margin: 5px;
    flex: 1;
    text-align: justify;
    overflow-y: auto;
    justify-content: flex-start;
    height: 454px;
  }
  .text-container::-webkit-scrollbar {
    width: 3px;
  }
  .text-container::-webkit-scrollbar-track {
    background: #212529;
  }
  .text-container::-webkit-scrollbar-thumb {
    background-color: black;
    border-radius: 3px;
    border: 0px solid #212529;
    opacity: 0.5;
  }
  /* .text-container {
    scrollbar-color: black #212529;
    scrollbar-width: none;
  } */
  .text {
    background-color: #212529;
  }
  /* Left hand side of content row */
  .image-container {
    justify-content: right;
    height: 474px;
    width: 474px;
  }
  .image-container img {
    height: 474px;
    width: 474px;
    /* position: absolute; */
  }
  .rounded-image {
    border-radius: 12px;
    height: 474px;
    float: right !important;
  }
  .dj-name-container {
    display: flex;
    max-width: fit-content;
    margin: 0 2px 0 0px;
    padding-right: 0px;
    align-items: top;
  }
  .dj-name {
    color: white;
    font-size: 20px;
    font-style: bold;
    min-width: fit-content;
    margin: 0 0 0 0px;
  }
  /* BUTTON */
  .buttons-container {
    display: flex;
    margin: 0 0 0 0;
    padding-left: 0px;
    align-items: center;
  }
  .select-button {
    background-color: transparent;
    border: 1px solid white;
    border-radius: 20px;
    color: white;
    font-size: 12px;
    padding: 1px 3px;
    cursor: pointer;
    align-items: center;
  }
  .select-button:hover {
    background-color: orange;
    color: white;
  }
  /* MICROOHONE */
  .microphone-icon {
    margin: 0 2px 0 0px;
    cursor: pointer;
    color: white;
    size: 18px;
    align-items: center;
  }
  .microphone-icon:hover {
    color: orange;
  }
  @keyframes blinking {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
  .microphone-icon.playing {
    color: orange;
    animation: blinking 1s infinite;
  }
  .microphone-icon.paused {
    color: orange;
    opacity: 0.5;
  }
}
/* XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX */
/* For large devices */
@media (min-width: 1025px) {
  .title {
    color: white;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  /* This is the Parant Row for ALL Content (image and text) */
  .content-row {
    justify-content: center;
    height: 500px;
  }
  /* Right hand side of content row */
  .text-column {
    display: flex;
    flex-direction: column;
    gap: 5px;
    height: 474px;
    width: 474px;
  }
  .text-row-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 5px;
    width: 474px;
    height: 20px;
    background-color: #212529;
  }
  .text-container {
    color: white;
    margin: 5px;
    flex: 1;
    text-align: justify;
    overflow-y: auto;
    justify-content: flex-start;
    height: 454px;
  }
  .text-container::-webkit-scrollbar {
    width: 3px;
  }
  .text-container::-webkit-scrollbar-track {
    background: #212529;
  }
  .text-container::-webkit-scrollbar-thumb {
    background-color: black;
    border-radius: 3px;
    border: 0px solid #212529;
    opacity: 0.5;
  }
  /* .text-container {
    scrollbar-color: black #212529;
    scrollbar-width: none;
  } */
  .text {
    background-color: #212529;
  }
  /* Left hand side of content row */
  .image-container {
    justify-content: right;
    height: 474px;
    width: 474px;
  }
  .image-container img {
    height: 474px;
    width: 474px;
    /* position: absolute; */
  }
  .rounded-image {
    border-radius: 12px;
    height: 474px;
    float: right !important;
  }
  .dj-name-container {
    display: flex;
    max-width: fit-content;
    margin: 0 2px 0 0px;
    padding-right: 0px;
    align-items: top;
  }
  .dj-name {
    color: white;
    font-size: 20px;
    font-style: bold;
    min-width: fit-content;
    margin: 0 0 0 0px;
  }
  /* BUTTON */
  .buttons-container {
    display: flex;
    margin: 0 0 0 0;
    padding-left: 0px;
    align-items: center;
  }
  .select-button {
    background-color: transparent;
    border: 1px solid white;
    border-radius: 20px;
    color: white;
    font-size: 12px;
    padding: 1px 3px;
    cursor: pointer;
    align-items: center;
  }
  .select-button:hover {
    background-color: orange;
    color: white;
  }
  /* MICROOHONE */
  .microphone-icon {
    margin: 0 2px 0 0px;
    cursor: pointer;
    color: white;
    size: 18px;
    align-items: center;
  }
  .microphone-icon:hover {
    color: orange;
  }
  @keyframes blinking {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
  .microphone-icon.playing {
    color: orange;
    animation: blinking 1s infinite;
  }
  .microphone-icon.paused {
    color: orange;
    opacity: 0.5;
  }
}
/*# sourceMappingURL=djsStyle.css.map */`, "",{"version":3,"sources":["webpack://./djsStyle.css","webpack://./client/Components/djsStyle.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ECCF;EACA,4DAA4D;EDC5D;IACE,uBAAA;IACA,cAAA;ECCF;EACA,mCAAmC;EDCnC;IACE,aAAA;IACA,sBAAA;IACA,QAAA;IACA,aAAA;IACA,YAAA;ECCF;EDEA;IACE,aAAA;IACA,2BAAA;IACA,mBAAA;IACA,gBAAA;IACA,YAAA;IACA,YAAA;IACA,yBAAA;ECAF;EDGA;IACE,YAAA;IACA,WAAA;IACA,OAAA;IACA,mBAAA;IACA,gBAAA;IACA,2BAAA;IACA,cAAA;ECDF;EDIA;IACE,UAAA;ECFF;EDKA;IACE,mBAAA;ECHF;EDMA;IACE,uBAAA;IACA,kBAAA;IACA,yBAAA;IACA,YAAA;ECJF;EACA;;;KAGG;EDQH;IACE,yBAAA;ECNF;EACA,kCAAkC;EDQlC;IACE,sBAAA;IACA,aAAA;IACA,YAAA;ECNF;EDSA;IACE,aAAA;IACA,YAAA;ICPA,wBAAwB;EAC1B;EDUA;ICRE,wBAAwB;IDUxB,aAAA;ICRA,6BAA6B;EAC/B;EDWA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;ECTF;EDYA;IACE,YAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,iBAAA;ECVF;EACA,WAAW;EDaX;IACE,aAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;ECXF;EDcA;IACE,6BAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;IACA,cAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;ECZF;EDeA;IACE,wBAAA;IACA,YAAA;ECbF;EACA,eAAe;EDgBf;IACE,mBAAA;IACA,eAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ECdF;EDiBA;IACE,aAAA;ECfF;EDkBA;IACE;MACE,UAAA;IChBF;IDkBA;MACE,YAAA;IChBF;IDkBA;MACE,UAAA;IChBF;EACF;EDmBA;IACE,aAAA;IACA,+BAAA;ECjBF;EDoBA;IACE,aAAA;IACA,YAAA;EClBF;AACF;ADqBA;EACE;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ECnBF;EACA,4DAA4D;EDqB5D;IACE,uBAAA;IACA,cAAA;ECnBF;EACA,mCAAmC;EDqBnC;IACE,aAAA;IACA,sBAAA;IACA,QAAA;IACA,aAAA;IACA,YAAA;ECnBF;EDsBA;IACE,aAAA;IACA,2BAAA;IACA,mBAAA;IACA,gBAAA;IACA,YAAA;IACA,YAAA;IACA,yBAAA;ECpBF;EDuBA;IACE,YAAA;IACA,WAAA;IACA,OAAA;IACA,mBAAA;IACA,gBAAA;IACA,2BAAA;IACA,aAAA;ECrBF;EDwBA;IACE,UAAA;ECtBF;EDyBA;IACE,mBAAA;ECvBF;ED0BA;IACE,uBAAA;IACA,kBAAA;IACA,yBAAA;IACA,YAAA;ECxBF;EACA;;;KAGG;ED4BH;IACE,yBAAA;EC1BF;EACA,kCAAkC;ED4BlC;IACE,sBAAA;IACA,aAAA;IACA,YAAA;EC1BF;ED6BA;IACE,aAAA;IACA,YAAA;IC3BA,wBAAwB;EAC1B;ED8BA;IACE,mBAAA;IACA,aAAA;IACA,uBAAA;EC5BF;ED+BA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;EC7BF;EDgCA;IACE,YAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,iBAAA;EC9BF;EACA,WAAW;EDiCX;IACE,aAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;EC/BF;EDkCA;IACE,6BAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EChCF;EDmCA;IACE,wBAAA;IACA,YAAA;ECjCF;EACA,eAAe;EDoCf;IACE,mBAAA;IACA,eAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EClCF;EDqCA;IACE,aAAA;ECnCF;EDsCA;IACE;MACE,UAAA;ICpCF;IDsCA;MACE,YAAA;ICpCF;IDsCA;MACE,UAAA;ICpCF;EACF;EDuCA;IACE,aAAA;IACA,+BAAA;ECrCF;EDwCA;IACE,aAAA;IACA,YAAA;ECtCF;AACF;AACA,mDAAmD;AACnD,sBAAsB;ADyCtB;EACE;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ECvCF;EACA,4DAA4D;EDyC5D;IACE,uBAAA;IACA,aAAA;ECvCF;EACA,mCAAmC;EDyCnC;IACE,aAAA;IACA,sBAAA;IACA,QAAA;IACA,aAAA;IACA,YAAA;ECvCF;ED0CA;IACE,aAAA;IACA,2BAAA;IACA,mBAAA;IACA,gBAAA;IACA,YAAA;IACA,YAAA;IACA,yBAAA;ECxCF;ED2CA;IACE,YAAA;IACA,WAAA;IACA,OAAA;IACA,mBAAA;IACA,gBAAA;IACA,2BAAA;IACA,aAAA;ECzCF;ED4CA;IACE,UAAA;EC1CF;ED6CA;IACE,mBAAA;EC3CF;ED8CA;IACE,uBAAA;IACA,kBAAA;IACA,yBAAA;IACA,YAAA;EC5CF;EACA;;;KAGG;EDgDH;IACE,yBAAA;EC9CF;EACA,kCAAkC;EDgDlC;IACE,sBAAA;IACA,aAAA;IACA,YAAA;EC9CF;EDiDA;IACE,aAAA;IACA,YAAA;IC/CA,wBAAwB;EAC1B;EDkDA;IACE,mBAAA;IACA,aAAA;IACA,uBAAA;EChDF;EDmDA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;ECjDF;EDoDA;IACE,YAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,iBAAA;EClDF;EACA,WAAW;EDqDX;IACE,aAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;ECnDF;EDsDA;IACE,6BAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;ECpDF;EDuDA;IACE,wBAAA;IACA,YAAA;ECrDF;EACA,eAAe;EDwDf;IACE,mBAAA;IACA,eAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ECtDF;EDyDA;IACE,aAAA;ECvDF;ED0DA;IACE;MACE,UAAA;ICxDF;ID0DA;MACE,YAAA;ICxDF;ID0DA;MACE,UAAA;ICxDF;EACF;ED2DA;IACE,aAAA;IACA,+BAAA;ECzDF;ED4DA;IACE,aAAA;IACA,YAAA;EC1DF;AACF;AACA,uCAAuC","sourcesContent":["@media (min-width: 320px) and (max-width: 480px) {\n  .title {\n    color: white;\n    font-size: 12px;\n    font-weight: bold;\n    text-align: center;\n  }\n  /* This is the Parant Row for ALL Content (image and text) */\n  .content-row {\n    justify-content: center;\n    height: 1000px;\n  }\n  /* Right hand side of content row */\n  .text-column {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    height: 375px;\n    width: 375px;\n  }\n\n  .text-row-header {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-left: 5px;\n    width: 375px;\n    height: 16px;\n    background-color: #212529;\n  }\n\n  .text-container {\n    color: white;\n    margin: 5px;\n    flex: 1;\n    text-align: justify;\n    overflow-y: auto;\n    justify-content: flex-start;\n    height: 1000px;\n  }\n\n  .text-container::-webkit-scrollbar {\n    width: 3px;\n  }\n\n  .text-container::-webkit-scrollbar-track {\n    background: #212529;\n  }\n\n  .text-container::-webkit-scrollbar-thumb {\n    background-color: black;\n    border-radius: 3px;\n    border: 0px solid #212529;\n    opacity: 0.5;\n  }\n\n  /* .text-container {\n    scrollbar-color: black #212529;\n    scrollbar-width: none;\n  } */\n\n  .text {\n    background-color: #212529;\n  }\n  /* Left hand side of content row */\n  .image-container {\n    justify-content: right;\n    height: 375px;\n    width: 375px;\n  }\n\n  .image-container img {\n    height: 375px;\n    width: 375px;\n    /* position: absolute; */\n  }\n\n  .rounded-image {\n    /* border-radius: 8px; */\n    height: 375px;\n    /* float: right !important; */\n  }\n\n  .dj-name-container {\n    display: flex;\n    max-width: fit-content;\n    margin: 0 2px 0 0px;\n    padding-right: 0px;\n    align-items: top;\n  }\n\n  .dj-name {\n    color: white;\n    font-size: 20px;\n    font-style: bold;\n    min-width: fit-content;\n    margin: 0 0 0 0px;\n  }\n\n  /* BUTTON */\n  .buttons-container {\n    display: flex;\n    margin: 0 0 0 0;\n    padding-left: 0px;\n    align-items: center;\n  }\n\n  .select-button {\n    background-color: transparent;\n    border: 1px solid white;\n    border-radius: 20px;\n    color: white;\n    font-size: 8px;\n    padding: 1px 3px;\n    cursor: pointer;\n    align-items: center;\n  }\n\n  .select-button:hover {\n    background-color: orange;\n    color: white;\n  }\n\n  /* MICROOHONE */\n  .microphone-icon {\n    margin: 0 2px 0 0px;\n    cursor: pointer;\n    color: white;\n    size: 18px;\n    align-items: center;\n  }\n\n  .microphone-icon:hover {\n    color: orange;\n  }\n\n  @keyframes blinking {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.5;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .microphone-icon.playing {\n    color: orange;\n    animation: blinking 1s infinite;\n  }\n\n  .microphone-icon.paused {\n    color: orange;\n    opacity: 0.5;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 1024px) {\n  .title {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n  /* This is the Parant Row for ALL Content (image and text) */\n  .content-row {\n    justify-content: center;\n    height: 1000px;\n  }\n  /* Right hand side of content row */\n  .text-column {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    height: 474px;\n    width: 474px;\n  }\n\n  .text-row-header {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-left: 5px;\n    width: 474px;\n    height: 20px;\n    background-color: #212529;\n  }\n\n  .text-container {\n    color: white;\n    margin: 5px;\n    flex: 1;\n    text-align: justify;\n    overflow-y: auto;\n    justify-content: flex-start;\n    height: 454px;\n  }\n\n  .text-container::-webkit-scrollbar {\n    width: 3px;\n  }\n\n  .text-container::-webkit-scrollbar-track {\n    background: #212529;\n  }\n\n  .text-container::-webkit-scrollbar-thumb {\n    background-color: black;\n    border-radius: 3px;\n    border: 0px solid #212529;\n    opacity: 0.5;\n  }\n\n  /* .text-container {\n    scrollbar-color: black #212529;\n    scrollbar-width: none;\n  } */\n\n  .text {\n    background-color: #212529;\n  }\n  /* Left hand side of content row */\n  .image-container {\n    justify-content: right;\n    height: 474px;\n    width: 474px;\n  }\n\n  .image-container img {\n    height: 474px;\n    width: 474px;\n    /* position: absolute; */\n  }\n\n  .rounded-image {\n    border-radius: 12px;\n    height: 474px;\n    float: right !important;\n  }\n\n  .dj-name-container {\n    display: flex;\n    max-width: fit-content;\n    margin: 0 2px 0 0px;\n    padding-right: 0px;\n    align-items: top;\n  }\n\n  .dj-name {\n    color: white;\n    font-size: 20px;\n    font-style: bold;\n    min-width: fit-content;\n    margin: 0 0 0 0px;\n  }\n\n  /* BUTTON */\n  .buttons-container {\n    display: flex;\n    margin: 0 0 0 0;\n    padding-left: 0px;\n    align-items: center;\n  }\n\n  .select-button {\n    background-color: transparent;\n    border: 1px solid white;\n    border-radius: 20px;\n    color: white;\n    font-size: 12px;\n    padding: 1px 3px;\n    cursor: pointer;\n    align-items: center;\n  }\n\n  .select-button:hover {\n    background-color: orange;\n    color: white;\n  }\n\n  /* MICROOHONE */\n  .microphone-icon {\n    margin: 0 2px 0 0px;\n    cursor: pointer;\n    color: white;\n    size: 18px;\n    align-items: center;\n  }\n\n  .microphone-icon:hover {\n    color: orange;\n  }\n\n  @keyframes blinking {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.5;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .microphone-icon.playing {\n    color: orange;\n    animation: blinking 1s infinite;\n  }\n\n  .microphone-icon.paused {\n    color: orange;\n    opacity: 0.5;\n  }\n}\n\n/* XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX */\n/* For large devices */\n@media (min-width: 1025px) {\n  .title {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n  /* This is the Parant Row for ALL Content (image and text) */\n  .content-row {\n    justify-content: center;\n    height: 500px;\n  }\n  /* Right hand side of content row */\n  .text-column {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    height: 474px;\n    width: 474px;\n  }\n\n  .text-row-header {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-left: 5px;\n    width: 474px;\n    height: 20px;\n    background-color: #212529;\n  }\n\n  .text-container {\n    color: white;\n    margin: 5px;\n    flex: 1;\n    text-align: justify;\n    overflow-y: auto;\n    justify-content: flex-start;\n    height: 454px;\n  }\n\n  .text-container::-webkit-scrollbar {\n    width: 3px;\n  }\n\n  .text-container::-webkit-scrollbar-track {\n    background: #212529;\n  }\n\n  .text-container::-webkit-scrollbar-thumb {\n    background-color: black;\n    border-radius: 3px;\n    border: 0px solid #212529;\n    opacity: 0.5;\n  }\n\n  /* .text-container {\n    scrollbar-color: black #212529;\n    scrollbar-width: none;\n  } */\n\n  .text {\n    background-color: #212529;\n  }\n  /* Left hand side of content row */\n  .image-container {\n    justify-content: right;\n    height: 474px;\n    width: 474px;\n  }\n\n  .image-container img {\n    height: 474px;\n    width: 474px;\n    /* position: absolute; */\n  }\n\n  .rounded-image {\n    border-radius: 12px;\n    height: 474px;\n    float: right !important;\n  }\n\n  .dj-name-container {\n    display: flex;\n    max-width: fit-content;\n    margin: 0 2px 0 0px;\n    padding-right: 0px;\n    align-items: top;\n  }\n\n  .dj-name {\n    color: white;\n    font-size: 20px;\n    font-style: bold;\n    min-width: fit-content;\n    margin: 0 0 0 0px;\n  }\n\n  /* BUTTON */\n  .buttons-container {\n    display: flex;\n    margin: 0 0 0 0;\n    padding-left: 0px;\n    align-items: center;\n  }\n\n  .select-button {\n    background-color: transparent;\n    border: 1px solid white;\n    border-radius: 20px;\n    color: white;\n    font-size: 12px;\n    padding: 1px 3px;\n    cursor: pointer;\n    align-items: center;\n  }\n\n  .select-button:hover {\n    background-color: orange;\n    color: white;\n  }\n\n  /* MICROOHONE */\n  .microphone-icon {\n    margin: 0 2px 0 0px;\n    cursor: pointer;\n    color: white;\n    size: 18px;\n    align-items: center;\n  }\n\n  .microphone-icon:hover {\n    color: orange;\n  }\n\n  @keyframes blinking {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.5;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .microphone-icon.playing {\n    color: orange;\n    animation: blinking 1s infinite;\n  }\n\n  .microphone-icon.paused {\n    color: orange;\n    opacity: 0.5;\n  }\n}\n","@media (min-width: 320px) and (max-width: 480px) {\n  .title {\n    color: white;\n    font-size: 12px;\n    font-weight: bold;\n    text-align: center;\n  }\n  /* This is the Parant Row for ALL Content (image and text) */\n  .content-row {\n    justify-content: center;\n    height: 1000px;\n  }\n  /* Right hand side of content row */\n  .text-column {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    height: 375px;\n    width: 375px;\n  }\n  .text-row-header {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-left: 5px;\n    width: 375px;\n    height: 16px;\n    background-color: #212529;\n  }\n  .text-container {\n    color: white;\n    margin: 5px;\n    flex: 1;\n    text-align: justify;\n    overflow-y: auto;\n    justify-content: flex-start;\n    height: 1000px;\n  }\n  .text-container::-webkit-scrollbar {\n    width: 3px;\n  }\n  .text-container::-webkit-scrollbar-track {\n    background: #212529;\n  }\n  .text-container::-webkit-scrollbar-thumb {\n    background-color: black;\n    border-radius: 3px;\n    border: 0px solid #212529;\n    opacity: 0.5;\n  }\n  /* .text-container {\n    scrollbar-color: black #212529;\n    scrollbar-width: none;\n  } */\n  .text {\n    background-color: #212529;\n  }\n  /* Left hand side of content row */\n  .image-container {\n    justify-content: right;\n    height: 375px;\n    width: 375px;\n  }\n  .image-container img {\n    height: 375px;\n    width: 375px;\n    /* position: absolute; */\n  }\n  .rounded-image {\n    /* border-radius: 8px; */\n    height: 375px;\n    /* float: right !important; */\n  }\n  .dj-name-container {\n    display: flex;\n    max-width: fit-content;\n    margin: 0 2px 0 0px;\n    padding-right: 0px;\n    align-items: top;\n  }\n  .dj-name {\n    color: white;\n    font-size: 20px;\n    font-style: bold;\n    min-width: fit-content;\n    margin: 0 0 0 0px;\n  }\n  /* BUTTON */\n  .buttons-container {\n    display: flex;\n    margin: 0 0 0 0;\n    padding-left: 0px;\n    align-items: center;\n  }\n  .select-button {\n    background-color: transparent;\n    border: 1px solid white;\n    border-radius: 20px;\n    color: white;\n    font-size: 8px;\n    padding: 1px 3px;\n    cursor: pointer;\n    align-items: center;\n  }\n  .select-button:hover {\n    background-color: orange;\n    color: white;\n  }\n  /* MICROOHONE */\n  .microphone-icon {\n    margin: 0 2px 0 0px;\n    cursor: pointer;\n    color: white;\n    size: 18px;\n    align-items: center;\n  }\n  .microphone-icon:hover {\n    color: orange;\n  }\n  @keyframes blinking {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.5;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  .microphone-icon.playing {\n    color: orange;\n    animation: blinking 1s infinite;\n  }\n  .microphone-icon.paused {\n    color: orange;\n    opacity: 0.5;\n  }\n}\n@media (min-width: 481px) and (max-width: 1024px) {\n  .title {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n  /* This is the Parant Row for ALL Content (image and text) */\n  .content-row {\n    justify-content: center;\n    height: 1000px;\n  }\n  /* Right hand side of content row */\n  .text-column {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    height: 474px;\n    width: 474px;\n  }\n  .text-row-header {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-left: 5px;\n    width: 474px;\n    height: 20px;\n    background-color: #212529;\n  }\n  .text-container {\n    color: white;\n    margin: 5px;\n    flex: 1;\n    text-align: justify;\n    overflow-y: auto;\n    justify-content: flex-start;\n    height: 454px;\n  }\n  .text-container::-webkit-scrollbar {\n    width: 3px;\n  }\n  .text-container::-webkit-scrollbar-track {\n    background: #212529;\n  }\n  .text-container::-webkit-scrollbar-thumb {\n    background-color: black;\n    border-radius: 3px;\n    border: 0px solid #212529;\n    opacity: 0.5;\n  }\n  /* .text-container {\n    scrollbar-color: black #212529;\n    scrollbar-width: none;\n  } */\n  .text {\n    background-color: #212529;\n  }\n  /* Left hand side of content row */\n  .image-container {\n    justify-content: right;\n    height: 474px;\n    width: 474px;\n  }\n  .image-container img {\n    height: 474px;\n    width: 474px;\n    /* position: absolute; */\n  }\n  .rounded-image {\n    border-radius: 12px;\n    height: 474px;\n    float: right !important;\n  }\n  .dj-name-container {\n    display: flex;\n    max-width: fit-content;\n    margin: 0 2px 0 0px;\n    padding-right: 0px;\n    align-items: top;\n  }\n  .dj-name {\n    color: white;\n    font-size: 20px;\n    font-style: bold;\n    min-width: fit-content;\n    margin: 0 0 0 0px;\n  }\n  /* BUTTON */\n  .buttons-container {\n    display: flex;\n    margin: 0 0 0 0;\n    padding-left: 0px;\n    align-items: center;\n  }\n  .select-button {\n    background-color: transparent;\n    border: 1px solid white;\n    border-radius: 20px;\n    color: white;\n    font-size: 12px;\n    padding: 1px 3px;\n    cursor: pointer;\n    align-items: center;\n  }\n  .select-button:hover {\n    background-color: orange;\n    color: white;\n  }\n  /* MICROOHONE */\n  .microphone-icon {\n    margin: 0 2px 0 0px;\n    cursor: pointer;\n    color: white;\n    size: 18px;\n    align-items: center;\n  }\n  .microphone-icon:hover {\n    color: orange;\n  }\n  @keyframes blinking {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.5;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  .microphone-icon.playing {\n    color: orange;\n    animation: blinking 1s infinite;\n  }\n  .microphone-icon.paused {\n    color: orange;\n    opacity: 0.5;\n  }\n}\n/* XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX */\n/* For large devices */\n@media (min-width: 1025px) {\n  .title {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n  /* This is the Parant Row for ALL Content (image and text) */\n  .content-row {\n    justify-content: center;\n    height: 500px;\n  }\n  /* Right hand side of content row */\n  .text-column {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    height: 474px;\n    width: 474px;\n  }\n  .text-row-header {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-left: 5px;\n    width: 474px;\n    height: 20px;\n    background-color: #212529;\n  }\n  .text-container {\n    color: white;\n    margin: 5px;\n    flex: 1;\n    text-align: justify;\n    overflow-y: auto;\n    justify-content: flex-start;\n    height: 454px;\n  }\n  .text-container::-webkit-scrollbar {\n    width: 3px;\n  }\n  .text-container::-webkit-scrollbar-track {\n    background: #212529;\n  }\n  .text-container::-webkit-scrollbar-thumb {\n    background-color: black;\n    border-radius: 3px;\n    border: 0px solid #212529;\n    opacity: 0.5;\n  }\n  /* .text-container {\n    scrollbar-color: black #212529;\n    scrollbar-width: none;\n  } */\n  .text {\n    background-color: #212529;\n  }\n  /* Left hand side of content row */\n  .image-container {\n    justify-content: right;\n    height: 474px;\n    width: 474px;\n  }\n  .image-container img {\n    height: 474px;\n    width: 474px;\n    /* position: absolute; */\n  }\n  .rounded-image {\n    border-radius: 12px;\n    height: 474px;\n    float: right !important;\n  }\n  .dj-name-container {\n    display: flex;\n    max-width: fit-content;\n    margin: 0 2px 0 0px;\n    padding-right: 0px;\n    align-items: top;\n  }\n  .dj-name {\n    color: white;\n    font-size: 20px;\n    font-style: bold;\n    min-width: fit-content;\n    margin: 0 0 0 0px;\n  }\n  /* BUTTON */\n  .buttons-container {\n    display: flex;\n    margin: 0 0 0 0;\n    padding-left: 0px;\n    align-items: center;\n  }\n  .select-button {\n    background-color: transparent;\n    border: 1px solid white;\n    border-radius: 20px;\n    color: white;\n    font-size: 12px;\n    padding: 1px 3px;\n    cursor: pointer;\n    align-items: center;\n  }\n  .select-button:hover {\n    background-color: orange;\n    color: white;\n  }\n  /* MICROOHONE */\n  .microphone-icon {\n    margin: 0 2px 0 0px;\n    cursor: pointer;\n    color: white;\n    size: 18px;\n    align-items: center;\n  }\n  .microphone-icon:hover {\n    color: orange;\n  }\n  @keyframes blinking {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.5;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  .microphone-icon.playing {\n    color: orange;\n    animation: blinking 1s infinite;\n  }\n  .microphone-icon.paused {\n    color: orange;\n    opacity: 0.5;\n  }\n}\n/*# sourceMappingURL=djsStyle.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
